<div *ngIf="loading$ | async" class="spinner-overlay" >
  <div class="spinner"></div>
</div>
